const FORM_URL = 'https://readdy.ai/api/form/daps2ffd3mjnincc44d0';

export interface ApplicationResult {
  ok: boolean;
  message: string;
}

/**
 * Submits the VILLAGARAGE dealer / partnership application.
 *
 * The payload is built directly from the live form element so browser AutoFill
 * values are captured. A separate module keeps the submit handler easy to swap
 * for a real API later.
 */
export async function submitDealerApplication(
  form: HTMLFormElement,
): Promise<ApplicationResult> {
  const data = new FormData(form);

  const honeypot = String(data.get('contact_alt') ?? '').trim();
  data.delete('contact_alt');

  if (honeypot) {
    return { ok: true, message: '' };
  }

  const params = new URLSearchParams();
  data.forEach((value, key) => {
    if (typeof value === 'string') {
      params.append(key, value);
    }
  });

  let responseText = '';
  try {
    const response = await fetch(FORM_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
    responseText = await response.text();

    let parsed:
      | { code?: string; meta?: { message?: string; detail?: string }; message?: string }
      | null = null;
    try {
      parsed = JSON.parse(responseText);
    } catch {
      parsed = null;
    }

    const serverMsg =
      parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';

    if (response.ok && parsed?.code === 'OK') {
      return { ok: true, message: '' };
    }

    return { ok: false, message: serverMsg };
  } catch {
    return { ok: false, message: responseText || '' };
  }
}